<template>
  <div class="c-nodes-settings">
    <settings-header title="Параметры слоя" />
    <div class="c-nodes-settings__container">
      <color-control
        :id="id"
        :config="stylesConfigs.style.paint"
        color-field="circle-color"
        opacity-field="circle-opacity"
      />
      <width-control
        :id="id"
        :config="stylesConfigs.style.paint"
        field="circle-radius"
        title="Размер точки"
      />
      <outline-control
        :id="id"
        type="nodes"
        :config="stylesConfigs.style.paint"
        color-field="circle-stroke-color"
        opacity-field="circle-stroke-opacity"
        width-field="circle-stroke-width"
      />
      <popup-control :id="id" />
    </div>
  </div>
</template>

<script>
import SettingsHeader from "../../settings-header/settings-header";
import ColorControl from "../controls/color";
import WidthControl from "../controls/width";
import OutlineControl from "../controls/outline";
import PopupControl from "../controls/popup";

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {
    SettingsHeader,
    ColorControl,
    WidthControl,
    OutlineControl,
    PopupControl
  },
  computed: {
    stylesConfigs() {
      return this.$store.state.calculations.stylesConfigs[this.id];
    }
  }
};
</script>

<style lang="scss">
.c-nodes-settings {
  flex: 1;
  display: flex;
  flex-direction: column;

  &__container {
    flex: 1;
    height: 0px;
    padding: 8px;
  }
}
</style>
